var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#604DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2501 9.0625V13.1458H28.4584V27.4375H8.04175V9.0625H18.2501ZM10.0834 25.3958H12.1251V23.3542H10.0834V25.3958ZM12.1251 21.3125H10.0834V19.2708H12.1251V21.3125ZM10.0834 17.2291H12.1251V15.1875H10.0834V17.2291ZM12.1251 13.1458H10.0834V11.1041H12.1251V13.1458ZM14.1668 25.3958H16.2084V23.3542H14.1668V25.3958ZM16.2084 21.3125H14.1668V19.2708H16.2084V21.3125ZM14.1668 17.2291H16.2084V15.1875H14.1668V17.2291ZM16.2084 13.1458H14.1668V11.1041H16.2084V13.1458ZM18.2501 25.3958H26.4168V15.1875H18.2501V17.2291H20.2918V19.2708H18.2501V21.3125H20.2918V23.3541H18.2501V25.3958ZM24.3751 17.2292H22.3334V19.2709H24.3751V17.2292ZM22.3334 21.3126H24.3751V23.3542H22.3334V21.3126Z",
    fill: "#604DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.d8db7133.svg";
export { ForwardRef as ReactComponent };